import React, { FC, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../constants/maximum-page-size";
import { EVENT_BASED_NOTIFICATION_TYPE_ID, SCHEDULE_NOTIFICATION_TYPE_ID } from "../../constants/notification-key";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import ModesColumns from "../../models/ColumnDefinitions/ModeColumns";
import { ListData } from "../../models/ListData";
import { ListQuery } from "../../models/ListQuery";
import ModeSearch from "../../models/search/ModeSearch";
import { getRuleDisplayType } from "../../services/notificationService";
import { appendFilter } from "../../utilities/filters";
import TableTab from "../tabs/table-tab";
import { WizardStepLayout } from "../wizard/wizard-summary-layout";


interface Props {
    onNext: (event: any) => void;
    setDescription: (discription: string) => void;
}

const NotificationTypeStep: FC<Props> = ({ onNext, setDescription}) => {
    const [taskSelected, setTaskSelected] = useState(false);
    const { translate } = useLocale();

    const onLocalNext = (event: any) => {
        if (event.task) {
            onNext({ ...event, id: event.id, task: event.task });
        }
    };

    const itemSelected = (selectedItem: any) => {
        if (selectedItem) {
            setTaskSelected(true);
            setDescription(selectedItem.label);
            onLocalNext({
                task: selectedItem.nameOriginal,
                id: selectedItem.id,
            });
            setTaskSelected(false);
        }
    };

    /** This method is temporary,
       just to display the supported notifications thus far,
       and hide the unsupported notifications.
     * Adapt this method to add supported notifications by
       adding to the supportedNotificationTypesIds array.
     */
    const getData = (): ((query?: ListQuery) => Promise<ListData>) => {
        const supportedNotificationTypesIds = [SCHEDULE_NOTIFICATION_TYPE_ID, EVENT_BASED_NOTIFICATION_TYPE_ID];
        return (listParameters?: ListQuery) =>
            getRuleDisplayType({
                ...listParameters,
                filters: appendFilter(
                    supportedNotificationTypesIds,
                    "NotificationTypeIds",
                    "id",
                    listParameters?.filters ?? [],
                    "=in=",
                ),
            });
    };

    return (
        <WizardStepLayout onNext={(e) => onLocalNext(e)} nextDisabled={!taskSelected}>
            <div className="pl-3">
                <TableContextProvider
                    usePagination
                    useTable
                    // dataMethod={getRuleDisplayType} // Uncomment this line when all notification types are supported
                    dataMethod={getData()} // Remove this line when all notification types are supported
                    tableDescriptor={ModesColumns}
                    searchDescriptor={ModeSearch}
                    disableSearch={true}
                    maxPageSize={DEF_PG_SIZE_WIZARD}
                    canExportReport={false}>
                    <TableTab
                        title={translate.byKey(
                            TranslationKeys.selectNotificationType,
                        )}
                        selectRows={false}
                        onRowClicked={itemSelected}
                        tableId={"scheduleNotificationTable"}
                        cyName="notificationType"/>
                </TableContextProvider>
            </div>
        </WizardStepLayout>
    );
}

export default NotificationTypeStep;
